import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_PROVINCES = 'SET_PROVINCES';

const setProvinces = payload => ({ type: SET_PROVINCES, payload });

export const setProvincesToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.PROVINCES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var provinces = {};
                    snapshot.forEach(function(province) {
                        var provinceVal = province.val();
                        provinces[provinceVal.id] = provinceVal.name;
                    });
                    dispatch(setProvinces(provinces));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setProvinces(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setProvinces(null));
        });
    };
};